import { useEffect, useState } from 'react';
import { format as dateFormat } from 'light-date';

/**
 * Display a date strig using the specified format handling Server to Client.
 */
export function DateFormat({ date, format }: { date: string; format: string }) {
  const [dateString, setDateString] = useState('');

  // update string to local time
  useEffect(() => {
    setDateString(dateFormat(new Date(date), format));
  }, [date, format]);

  return <>{dateString}</>;
}
